// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class IPrescription {
    'daySupply'?: string;
    'directions'?: string;
    'frequency'?: number;
    'ndc': string;
    'quantity'?: number;
    'refills'?: number;
    'writtenOn'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof IPrescription>> = [
        {
            "name":     "daySupply",
            "baseName": "daySupply",
            "type":     "string"
        },
        {
            "name":     "directions",
            "baseName": "directions",
            "type":     "string"
        },
        {
            "name":     "frequency",
            "baseName": "frequency",
            "type":     "number"
        },
        {
            "name":     "ndc",
            "baseName": "ndc",
            "type":     "string"
        },
        {
            "name":     "quantity",
            "baseName": "quantity",
            "type":     "number"
        },
        {
            "name":     "refills",
            "baseName": "refills",
            "type":     "number"
        },
        {
            "name":     "writtenOn",
            "baseName": "writtenOn",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return IPrescription.attributeTypeMap;
    }
}
